import { SERVER_URL } from "../../api";
import axios from 'axios'
import FormData from "form-data";
import { getHeaderWithToken } from "../../helpers/func";

export const IMPORT_PATTERN_REQUEST = 'IMPORT_PATTERN_REQUEST';
export const IMPORT_PATTERN_SUCCESS = 'IMPORT_PATTERN_SUCCESS';
export const IMPORT_PATTERN_ERROR = 'IMPORT_PATTERN_ERROR';

export const importPatternPdf = (pdfFile, patternName) => {
    let headers = getHeaderWithToken();

    const formdata = new FormData();
    formdata.append('pdf', pdfFile);
    if (patternName) {
        formdata.append('patternName', patternName);
    }

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({ type: IMPORT_PATTERN_REQUEST })
            axios({
                method: 'POST',
                url: `${SERVER_URL}v1/pattern-import/upload`,
                headers: headers,
                data: formdata
            }).then(function (response) {
                dispatch({ type: IMPORT_PATTERN_SUCCESS, payload: response })
                resolve(response);
            }).catch(function (error) {
                dispatch({ type: IMPORT_PATTERN_ERROR, payload: error })
                reject(error.response)
            })
        })
    }
}

// Not wired into redux state — the panel polls this directly on an
// interval and reads the response, same low-ceremony pattern already used
// elsewhere in this app for non-websocket status polling.
export const getPatternImportStatus = (patternId) => {
    let headers = getHeaderWithToken();
    return axios({
        method: 'GET',
        url: `${SERVER_URL}v1/pattern-import/${patternId}/status`,
        headers: headers,
    }).then((response) => response.data);
}
